
export class SlackLogManager {
    static  getEnv(){
        let env = process.env.VUE_APP_FB_PROJECTID.split("mira-merge---")[1]
        let url = "https://config-mira-merge-development.web.app"
        if (process.env.VUE_APP_FB_PROJECTID == 'mira-merge---staging'){
            url = "https://config-mira-merge-staging.web.app"
        }else if(process.env.VUE_APP_FB_PROJECTID == 'mira-merge---production'){
            url = "https://config-mira-merge-production.web.app"
        }
        return " <"+url+"|"+env+">"
    }
    static log(data) {
        //return;
        fetch('https://hooks.slack.com/services/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',{
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded"},
            body: JSON.stringify(data)
        })
            .then((data)=>{
                console.error(`succes`, data.status);
            })
            .catch((error) => {
                console.error(`error`, error);
            })
    }
}